<script lang="ts">
	import SignUpPopup from '$lib/components/b2c/SignUpPopup.svelte';

	let signUpPopup: SignUpPopup;
</script>

<SignUpPopup bind:this={signUpPopup} />

<button
	on:click={() => {
		signUpPopup.toggleSignup('', 'Sign in to continue');
	}}
	type="button"
	class="rounded-md bg-emerald-50 px-3.5 py-2.5 text-sm font-semibold text-emerald-600 shadow-sm hover:bg-emerald-100"
	>See all apps</button
>
